import React from 'react';

export const SidebarContext = React.createContext(null);

export const SidebarProvider = React.memo(({ children }) => {
    const [sidebarVisibility, setSidebarVisibility] = React.useState({
        notificationSidebarVisibility: false,
        navigationPanelVisibility: false,
        attachmentSidebarVisibility: false,
        additionalInfoSidebar: {
            visibility: false,
            contentType: null,
        },
        filterSidebarVisibility: false,
        keyboardSidebarVisibility: false,
    });

    const handleToggleAttachmentSidebar = React.useCallback((value) => {
        setSidebarVisibility((prevState) => ({
            ...prevState,
            attachmentSidebarVisibility: value === undefined ? !prevState.attachmentSidebarVisibility : value,
        }));
    }, []);

    const handleToggleAdditionalInfoSidebar = React.useCallback((value) => {
        setSidebarVisibility((prevState) => ({
            ...prevState,
            additionalInfoSidebar: {
                visibility: value === undefined ? false : true,
                contentType: value,
            },
        }));
    }, []);

    const handleToggleNavigationPanel = React.useCallback((value) => {
        setSidebarVisibility((prevState) => ({
            ...prevState,
            navigationPanelVisibility: value === undefined ? !prevState.navigationPanelVisibility : value,
        }));
    }, []);

    const handleToggleNotificationSidebar = React.useCallback(() => {
        setSidebarVisibility((prevState) => ({
            ...prevState,
            notificationSidebarVisibility: !prevState.notificationSidebarVisibility,
        }));
    }, []);

    const handleToggleFilterSidebar = React.useCallback((value) => {
        setSidebarVisibility((prevState) => ({
            ...prevState,
            filterSidebarVisibility: value === undefined ? !prevState.filterSidebarVisibility : value,
        }));
    }, []);

    const handleCloseSidebar = React.useCallback(() => {
        setSidebarVisibility({
            notificationSidebarVisibility: false,
            navigationPanelVisibility: false,
        });
    }, []);

    const handleCloseAllSidebar = React.useCallback(() => {
        setSidebarVisibility({
            notificationSidebarVisibility: false,
            navigationPanelVisibility: false,
            attachmentSidebarVisibility: false,
            additionalInfoSidebar: {
                visibility: false,
                contentType: null,
            },
            filterSidebarVisibility: false,
        });
    }, []);

    const handleToggleKeyboardSidebar = React.useCallback((value) => {
        setSidebarVisibility((prevState) => ({
            ...prevState,
            keyboardSidebarVisibility: value === undefined ? !prevState.keyboardSidebarVisibility : value,
        }));
    }, []);

    const value = React.useMemo(
        () => ({
            sidebarVisibility,
            setSidebarVisibility,
            handleToggleAttachmentSidebar,
            handleToggleAdditionalInfoSidebar,
            handleToggleKeyboardSidebar,
            handleToggleNavigationPanel,
            handleToggleNotificationSidebar,
            handleToggleFilterSidebar,
            handleCloseSidebar,
            handleCloseAllSidebar,
        }),
        [sidebarVisibility]
    );

    return <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>;
});
